import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from "react";
const NotificationProviderFactory = ({ notificationContextProvider: NotificationContext, notificationNode: NotificationNode }) => {
    const NotificationProvider = ({ children, notificationShowDurationMs = 5000, }) => {
        const [notificationText, setNotificationText] = useState(null);
        const [notificationDuration, setNotificationDuration] = useState(notificationShowDurationMs);
        const showNotification = useCallback((text, duration = notificationShowDurationMs) => {
            setNotificationText(text);
            setNotificationDuration(duration);
        }, [notificationShowDurationMs]);
        const handleClose = () => setNotificationText(null);
        return (_jsxs(NotificationContext.Provider, { value: { showNotification }, children: [children, notificationText && (_jsx(NotificationNode, { text: notificationText, onClose: handleClose, duration: notificationDuration }))] }));
    };
    return NotificationProvider;
};
export const createNotifier = (NotificationNode) => {
    const NotificationContext = createContext(undefined);
    const NotificationProvider = NotificationProviderFactory({
        notificationContextProvider: NotificationContext,
        notificationNode: NotificationNode
    });
    const useNotifier = () => {
        const context = useContext(NotificationContext);
        if (!context) {
            throw new Error("Notifier provider is missing");
        }
        return context;
    };
    return {
        NotificationProvider,
        useNotifier,
    };
};
